// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles-module--categories--1UZyM"};